import React, { Component } from 'react'
import ReactTable from 'react-table'
import pdfIcon from '../../assets/image/pdf.png'
import { port, post } from '../../service/index'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'
import { setNumberOfPdf } from '../../redux/pdf/actions'

const columns = [
    {
        id: 'readHeader',
        minWidth: 200,
        Header: <p style={{ fontSize: 18, color: 'rgb(115, 213, 216)' }} >วาระการประชุม</p>,
        accessor: t => t.readHeader,
        style: { padding: 0, border: 'none', height: 48 },
        headerClassName: 'normal-header-table',
        headerStyle: { display: 'flex', justifyContent: 'center', alignItems: 'center', height: 48 },
        Cell: props =>
            <div style={{ paddingLeft: 10, display: 'flex', alignItems: 'center', flexDirection: 'row', height: '100%', background: props.index % 2 == 0 ? '#fff' : 'rgb(249, 249, 249)', fontSize: 16 }} >{props.value.read ? <img style={{ width: 10 }} src={require('../../assets/icon/check.png')} /> : null}<div style={{ paddingLeft: props.value.read ? 10 : 20, display: 'flex', alignItems: 'center', height: '100%', background: props.index % 2 == 0 ? '#fff' : 'rgb(249, 249, 249)', fontSize: 16 }} ><span>{props.value.title}</span></div></div> // Custom cell components!
    },
    {
        Header: <p style={{ fontSize: 18, color: 'rgb(115, 213, 216)' }} >วันที่ประชุม</p>,
        accessor: 'meeting_time',
        style: { padding: 0, border: 'none', height: 48 },
        headerClassName: 'normal-header-table',
        headerStyle: { display: 'flex', justifyContent: 'center', alignItems: 'center', height: 48 },
        Cell: props =>
            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%', background: props.index % 2 == 0 ? '#fff' : 'rgb(249, 249, 249)', fontSize: 10, fontSize: 16 }} ><span>{props.value.split('T')[0]}</span></div> // Custom cell components!
    },
    {
        Header: <p style={{ fontSize: 18, color: 'rgb(115, 213, 216)' }} >เวลาประชุม</p>,
        accessor: 'meeting_time',
        style: { padding: 0, border: 'none', height: 48 },
        headerClassName: 'normal-header-table',
        headerStyle: { display: 'flex', justifyContent: 'center', alignItems: 'center', height: 48 },
        Cell: props => {
            const time = props.value.split('T')[1] ? props.value.split('T')[1].split('.')[0] : '00:00'
            const hh = String(Number(time.split(":")[0]) + 7)
            const mm = time.split(":")[1]
            return (
                <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%', background: props.index % 2 == 0 ? '#fff' : 'rgb(249, 249, 249)', fontSize: 10, fontSize: 16 }} ><span>{hh + ":" + mm}</span></div> // Custom cell components!    
            )
        }
    },
    {
        id: 'link',
        Header: <p style={{ fontSize: 18, color: 'rgb(115, 213, 216)' }} >เอกสาร</p>,
        accessor: t => t.link,
        style: { padding: 0, border: 'none', height: 48 },
        headerClassName: 'normal-header-table',
        headerStyle: { display: 'flex', justifyContent: 'center', alignItems: 'center', height: 48 },
        Cell: props => <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%', background: props.index % 2 == 0 ? '#fff' : 'rgb(249, 249, 249)', fontSize: 16 }}> {props.value.pdf ? <Link to={{ pathname: '/conferenceDetail/' + props.value.conference_id, state: { url: props.value.url, title: props.value.title, doc_id: props.value.doc_id, document_name: props.value.document_name } }} ><img src={pdfIcon} style={{ width: 20, }} /></Link> : null}</div>
    }
]


class MeetingTable extends Component {

    constructor(props) {
        super(props)

        this.state = {
            data: []
        }
    }

    Download = async () => {
        console.log('Download')
        try {
            const { conference_id } = this.props
            const { token } = this.props.login.user
            window.open(port + '/zip/' + conference_id, '_blank')

        } catch (err) {
            console.log(err)
        }
    }

    componentDidMount = async () => {
        try {
            const { token } = this.props.login.user
            const data = await post('/get_sub_conference', { conference_id: this.props.conference_id }, token)
            const { result } = data

            this.setState({
                data: result.map(el => ({
                    readHeader: {
                        title: el.title,
                        read: el.read,
                    },
                    meeting_time: el.meeting_time,
                    link: {
                        conference_id: el.id,
                        pdf: el.document_name ? true : false,
                        url: el.url,
                        title: el.title,
                        doc_id: el.doc_id,
                        document_name: el.document_name
                    }
                }))
            })
            this.props.setNumberOfPdf(result.length)
        } catch (err) {
            console.log(err)
        }
    }


    render() {
        return (
            <div style={{ width: '100%', padding: 8, marginTop: 20, marginRight: 20, marginBottom: 20 }} className='card' >
                <div style={{ display: 'flex', width: '100%', justifyContent: 'space-between', alignItems: 'center', marginBottom: 10 }} >
                    <p style={{ fontSize: 25, marginRight: 10 }} >วาระการประชุม</p>
                    <a onClick={this.Download} >ดาวน์โหลดทั้งหมด</a>
                </div>
                <ReactTable
                    data={this.state.data}
                    columns={columns}
                    showPageSizeOptions={false}
                    defaultPageSize={8}
                    style={{ width: '100%' }}
                    sortable={false}
                    resizable={false}
                />
            </div>
        )
    }
}

const ProfileItem = ({ name, picture, position, index }) => {
    return (
        <div className='meeting-profile' style={{ backgroundColor: index % 2 == 0 ? 'rgb(211, 242, 242)' : 'rgb(207, 238, 238)', display: 'flex', height: '100%' }} >
            <img src={picture} className='meeting-profile-image' />
            <span>
                <p style={{ fontSize: 12 }} >{name}</p>
                <p style={{ fontSize: 10 }} >{position}</p>
            </span>
        </div>
    )
}

const mapStateToProps = (state) => ({
    login: state.login
})


const mapDispatchToProps = dispatch => ({
    setNumberOfPdf: payload => dispatch(setNumberOfPdf(payload))
})

export default connect(mapStateToProps, mapDispatchToProps)(MeetingTable)

const mockData = [
    {
        meeting_name: 'การเตรียมรับมือนำ้ท่วม',
        date: '23/10/2560',
        time: '14.30 น.',
        pdf: 1,
    },
    {
        meeting_name: 'การเตรียมรับมือนำ้ท่วม',
        date: '23/10/2560',
        time: '14.30 น.',
        pdf: 1,
    },
    {
        meeting_name: 'การเตรียมรับมือนำ้ท่วม',
        date: '23/10/2560',
        time: '14.30 น.',
        pdf: 1,
    },
    {
        meeting_name: 'การเตรียมรับมือนำ้ท่วม',
        date: '23/10/2560',
        time: '14.30 น.',
        pdf: 0,
    },
    {
        meeting_name: 'การเตรียมรับมือนำ้ท่วม',
        date: '23/10/2560',
        time: '14.30 น.',
        pdf: 1,
    },
    {
        meeting_name: 'การเตรียมรับมือนำ้ท่วม',
        date: '23/10/2560',
        time: '14.30 น.',
        pdf: 1,
    },
]


// WEBPACK FOOTER //
// ./src/components/Table/MeetingTable.js